import React, {FC, forwardRef} from 'react';

export const Item: FC<any> = forwardRef(({id, ...props}, ref) => {
  return (
    <div {...props} ref={ref}>
      {props.children}
    </div>
  )
});